/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, DatePicker, Form, Input, Select, Table, Tag } from 'antd';
import { FormComponentProps } from 'antd/es/form';
import { errorHandle } from '../../services';
import {
    DEFAULT_PAGE_SIZE,
    LOG_ACTION_OPTIONS,
    LOG_RESULT_OPTIONS,
    PAGE_SIZE_OPTIONS,
} from './constants';
import { fetchLogPage, mapLogItem, pickPageResult } from './api';

const { Option } = Select;
const { RangePicker } = DatePicker;

const cleanParams = (params: Record<string, any>) => {
    const next = { ...params };
    Object.keys(next).forEach((key) => {
        if (next[key] === undefined || next[key] === null || next[key] === '') {
            delete next[key];
        }
    });
    return next;
};

const LogsTabCom = ({ form }: FormComponentProps) => {
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [searchParams, setSearchParams] = useState<Record<string, any>>({});
    const [listData, setListData] = useState<any[]>([]);

    const fetchList = (query: Record<string, any> = {}) => {
        const merged = {
            page: pageNum,
            per_page: pageSize,
            ...searchParams,
            ...query,
        };
        const payload = cleanParams(merged);
        setLoading(true);
        fetchLogPage(payload)
            .then((res: any) => {
                const { list, total: nextTotal } = pickPageResult(res);
                setListData(list.map((item: any, index: number) => mapLogItem(item, index)));
                setTotal(nextTotal);
                setPageNum(payload.page || 1);
                setPageSize(payload.per_page || pageSize);
            })
            .catch(errorHandle)
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchList({ page: 1, per_page: pageSize });
    }, []);

    const handleSearch = (e?: React.FormEvent) => {
        if (e) {
            e.preventDefault();
        }
        form.validateFields((_err: any, values: any) => {
            const params = {
                sku_code: values.sku ? values.sku.trim() : undefined,
                spu_code: values.spu ? values.spu.trim() : undefined,
                action: values.action,
                result: values.result,
                start_time:
                    values.executeTime && values.executeTime[0]
                        ? values.executeTime[0].format('YYYY-MM-DD HH:mm:ss')
                        : undefined,
                end_time:
                    values.executeTime && values.executeTime[1]
                        ? values.executeTime[1].format('YYYY-MM-DD HH:mm:ss')
                        : undefined,
            };
            setSearchParams(params);
            fetchList({ ...params, page: 1, per_page: pageSize });
        });
    };

    const handleReset = () => {
        form.resetFields();
        setSearchParams({});
        fetchList({
            page: 1,
            per_page: pageSize,
            sku_code: undefined,
            spu_code: undefined,
            action: undefined,
            result: undefined,
            start_time: undefined,
            end_time: undefined,
        });
    };

    const columns: any[] = [
        { title: 'SKU', dataIndex: 'sku', key: 'sku', width: 150 },
        { title: 'SPU', dataIndex: 'spu', key: 'spu', width: 140 },
        { title: '动作', dataIndex: 'action', key: 'action', width: 120 },
        { title: '触发原因', dataIndex: 'reason', key: 'reason', width: 180 },
        {
            title: '变更前',
            dataIndex: 'before',
            key: 'before',
            width: 280,
            render: (text: string) => <div className="shelf-rule__cell-wrap">{text}</div>,
        },
        {
            title: '变更后',
            dataIndex: 'after',
            key: 'after',
            width: 280,
            render: (text: string) => <div className="shelf-rule__cell-wrap">{text}</div>,
        },
        { title: '执行时间', dataIndex: 'executeTime', key: 'executeTime', width: 180 },
        {
            title: '结果',
            dataIndex: 'result',
            key: 'result',
            width: 80,
            render: (text: string) =>
                text === '成功' ? <Tag color="green">{text}</Tag> : <Tag color="red">{text}</Tag>,
        },
        { title: '失败原因', dataIndex: 'failReason', key: 'failReason', width: 120 },
    ];

    return (
        <div>
            <Form layout="inline" onSubmit={handleSearch} className="shelf-rule__filter">
                <Form.Item label="SKU">
                    {form.getFieldDecorator('sku')(
                        <Input placeholder="请输入" style={{ width: 160 }} />
                    )}
                </Form.Item>
                <Form.Item label="SPU">
                    {form.getFieldDecorator('spu')(
                        <Input placeholder="请输入" style={{ width: 160 }} />
                    )}
                </Form.Item>
                <Form.Item label="动作">
                    {form.getFieldDecorator('action')(
                        <Select allowClear placeholder="请选择" style={{ width: 140 }}>
                            {LOG_ACTION_OPTIONS.map((item) => (
                                <Option key={item.value} value={item.value}>
                                    {item.label}
                                </Option>
                            ))}
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label="结果">
                    {form.getFieldDecorator('result')(
                        <Select allowClear placeholder="请选择" style={{ width: 120 }}>
                            {LOG_RESULT_OPTIONS.map((item) => (
                                <Option key={item.value} value={item.value}>
                                    {item.label}
                                </Option>
                            ))}
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label="执行时间">
                    {form.getFieldDecorator('executeTime')(
                        <RangePicker showTime placeholder={['开始', '结束']} />
                    )}
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        查询
                    </Button>
                    <Button style={{ marginLeft: 8 }} onClick={handleReset}>
                        重置
                    </Button>
                </Form.Item>
            </Form>
            <Table
                rowKey="id"
                loading={loading}
                columns={columns}
                dataSource={listData}
                scroll={{ x: 1600 }}
                pagination={{
                    total,
                    current: pageNum,
                    pageSize,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: PAGE_SIZE_OPTIONS,
                    showTotal: (count) => `共 ${count} 条记录`,
                    onChange: (page) => {
                        fetchList({ page, per_page: pageSize });
                    },
                    onShowSizeChange: (_current, size) => {
                        fetchList({ page: 1, per_page: size });
                    },
                }}
            />
        </div>
    );
};

export const LogsTab = Form.create()(LogsTabCom);
